import React, { FC, ReactNode } from "react";

import { StyledCamelBottom } from "./CamelBottom.styled";

type Props = {
    children: ReactNode;
};

const CamelBottom: FC<Props> = ({ children }: Props) => (
    <StyledCamelBottom>{children}</StyledCamelBottom>
);

export default CamelBottom;
